import React from 'react';
import { Grid } from '@material-ui/core';
// import { Link } from 'react-router-dom';
import Page from '../../layout/components/PageAuth.jsx';
// import LoginForm from './forms/LoginForm';
import LogoColor from '../../assets/images/logo-master-color.png';
// import Footer from '../../layout/components/FooterAuth';
import RightContent from './common/ContentRightSignupAmz';
import LoginOptionAmz from './common/LoginOptionAmz';
// import { _route } from '../../utils/sg.js';
import free from '../../assets/icons/amz-free.svg';
// import ads from '../../assets/icons/amz-expert.svg';
// import human from '../../assets/icons/amz-human.svg';
// import clock from '../../assets/icons/amz-clock.svg';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useSelector } from 'react-redux';

function Login() {
  const today = new Date();
  const { org } = useSelector(({ auth }) => auth);

  return (
    <Page title="Login">
      <Grid container className="auth_viewAmz">
        <Grid item lg={12} md={12} sm={12} xs={12} className="auth_view_contentAmz customScrollbarAmz">
          <div className="signup_holderAmz">
            <div className="web_show">
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_authAmz" />
              </a>
            </div>
            {/* <div className="signin_link web_show">
              Don't have an account?
              <Link to={_route('register')} className="login_acc_link">
                Create
              </Link>
            </div> */}
          </div>
          <div className="mob_show">
            <div>
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="form_main_content">
            <div className="signup_form_holder_amz">
              <div className="title_reg_right_amz">
                Welcome to SellerGeni <span className="waveHand">👋</span>
              </div>
              <div className="subtitle_reg_right_amz_holder">
                <p className="subtitle_reg_right_amz">
                  Thank you for choosing SellerGeni's 2-months free tool as part of the Elevate Program. Please read the
                  program information below.
                </p>
              </div>

              {/* <div className="sigin_link_mob mob_show">
                Don't have an account?
                <Link to={_route('register')} className="login_acc_link">
                  Create Account
                </Link>
              </div> */}
              {/* <LoginForm /> */}

              <LoginOptionAmz />
              <div className="footer_tc_text">
                By registering, you agree to SellerGeni's&nbsp;
                <a
                  underline="always"
                  color="text.primary"
                  href="https://sellergeni.com/terms-and-privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  T&C.
                </a>
              </div>
              <div className="slogan-sm-offer-holder-amz">
                <div className="slogan-sm-offer-amz">
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054', paddingRight: '20px' }}>
                    <div>
                      <img src={free} />
                    </div>
                    <div>2 months FREE Ads Management service.</div>
                  </div>
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054', paddingRight: '0px' }}>
                    <div>
                      <CheckCircleOutlineRoundedIcon />
                    </div>
                    <div>Amazon Verified Partner.</div>
                  </div>
                </div>
                {/* <div className="slogan-sm-offer-amz slogan-sm-offer-amzRight">
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054' }}>
                    <div>
                      <img src={human} />
                    </div>
                    <div> Account Manager Support.</div>
                  </div>
                  <div className="slogan-sm-offer-single-amz" style={{ color: '#344054' }}>
                    <div>
                      <img src={clock} />
                    </div>
                    <div>Save 90% time with automation.</div>
                  </div>
                </div> */}
              </div>

              {/* service included */}
              <div className="signup_holder_amz_servicelist_holder">
                <div style={{ height: '2px', background: 'rgb(0 0 0 / 8%)' }}></div>
                <div className="signup_holder_amz_list_box">
                  <div style={{ fontSize: '18px', fontWeight: '600', textAlign: 'left' }}>Program Benefits</div>
                  <div>
                    <ul className="signup_holder_amz_servicelist">
                      <li>
                        <div className="signup_holder_amz_servicelist_heading">📊 Audit Planning</div>

                        <ul className="signup_holder_amz_servicelist_ul">
                          <li>
                            Account health audit, Keyword Analysis, Search Term analysis, Account campaign structure Audit,
                            Search Impression share, Organic Performance, Ratings/Reviews
                          </li>
                          <li>Generate overall Audit, Budget, Sales projection, ASIN campaign Reports</li>
                          <li>2 Months Projection report and Kick-off call (30 min)</li>
                        </ul>
                      </li>

                      <li>
                        <div className="signup_holder_amz_servicelist_heading">🚀 Structure Fix and GeniLaunch</div>

                        <ul className="signup_holder_amz_servicelist_ul">
                          <li>Create Auto, Manual SP campaigns, SBV / SBA campaigns, SDV / SDA campaigns</li>
                          <li>Create theme based Sponsored Products, Sponsored Brand and Sponsored Display campaigns</li>
                          <li>Fix existing Campaign Structure</li>
                        </ul>
                      </li>

                      <li>
                        <div className="signup_holder_amz_servicelist_heading">💰 AutoPilot - Campaign Optimization</div>

                        <ul className="signup_holder_amz_servicelist_ul">
                          <li>
                            Bid Optimization, Rank Improvement for ASIN-Keywords, Daily Bidding for keywords and Targets,
                            Automated Budget update, Rank Improvement for ASIN-Keywords.
                          </li>
                          <li>Remove negative Search Terms, Targets, and Keywords</li>
                          <li>
                            Harvest from Auto campaigns to Manual campaigns, Analyse search terms and add them as targets,
                            Research and add new keywords and Targets (up-to 100 targets).
                          </li>
                        </ul>
                      </li>

                      <li>
                        <div className="signup_holder_amz_servicelist_heading">📄 Weekly Automated Reports</div>

                        <ul className="signup_holder_amz_servicelist_ul">
                          <li>Get weekly automated reports in email and Whatsapp.</li>
                          <li>Login anytime to the tool the check your account performance.</li>
                        </ul>
                      </li>

                      <li>
                        <div className="signup_holder_amz_servicelist_heading">🕐 Bi-Weekly meeting</div>

                        <ul className="signup_holder_amz_servicelist_ul">
                          <li>
                            Dedicated 30min call with account manager and Get help using SellerGeni Whatsapp chat support.
                          </li>
                          <li>Login anytime to the tool the check your account performance.</li>
                        </ul>
                      </li>

                      <li>
                        <div className="signup_holder_amz_servicelist_heading">💻 Free access to SellerGeni AI Tool</div>

                        <ul className="signup_holder_amz_servicelist_ul">
                          <li>Complete Access to the Tool and Monitor Real-time data using SellerGeni Dashboard.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="signup_holder_amz_notlist_holder">
                  <div className="signup_holder_amz_notlist_holderLeft">
                    <WarningAmberRoundedIcon />
                  </div>
                  <div className="signup_holder_amz_notlist_holderright">
                    <div style={{ fontSize: '18px', fontWeight: '600', textAlign: 'left', color: '#B54708' }}>
                      What is Not Included
                    </div>
                    <ul className="signup_holder_amz_notservicelist">
                      <li>Catalog creation, Updating Catalog(Title, Description, Backend keywords, price, image etc.)</li>
                      <li>A+. B+, Product videos, Brand collateral and Product image.</li>
                      <li>
                        Inventory updates, Order processing, Payment reconciliation, Tax reports, Business reports, Pricing
                        rules and other sellercentral related activities.
                      </li>
                      <li>Brand Registry, FBA registry, Vendor central and Easy ship management.</li>
                      <li>SAFE-T claims, Return management, Pickup slots and fraudulent orders.</li>
                      <li>
                        Buy-Box, Fraudulent orders, Account health, Account suspension and any seller performance related
                        services.
                      </li>
                      <li>Case creation, Payment failure and ASIN suspension.</li>
                      <li>Calls outside dedicated bi-weekly schedule.</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* service not included */}
            </div>
          </div>
        </Grid>

        <RightContent />
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            background: '#f7f2ff',
            padding: '2em 10px',
          }}
        >
          {' '}
          {/* <Footer /> */}
          By creating an account on SellerGeni, you confirm that you agree with our&nbsp;
          <a
            underline="always"
            color="text.primary"
            href="https://sellergeni.com/terms-and-privacy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'contents' }}
          >
            Terms & Privacy Policy
          </a>
          &nbsp;
          {today.getFullYear()} {org?.name}, All Rights Reserved.
        </Grid>
      </Grid>
    </Page>
  );
}

export default Login;
